module.exports = __webpack_public_path__ + "img/eco.8cb1f6ad.webp";